import { CompositePackagingModel } from './composite-packaging.model';
import { InnerPackagingModel } from './inner-packaging.model';
import { OverPackagingModel } from './over-packaging.model';
import { SinglePackagingModel } from './single-packaging.model';

export class Packages {
  SinglePackagingItems: SinglePackagingModel[] = [];
  CompositePackagingItems: CompositePackagingModel[] = [];
  InnerPackagingItems: InnerPackagingModel[] = [];
  OverpackPackagingItems: OverPackagingModel[] = [];
}
